<template>
  <div>
    <form @submit.prevent="handleSubmit(!v$.$invalid)">
      <div class="formgrid grid">
        <div class="field col-12">
          <label>Kode Transfer </label>
          <InputText v-model="form.kt_no" class="w-full" disabled> </InputText>
        </div>
        <div class="field col-12 md:col-12">
          <label>Tanggal Kas Transfer</label>
          <Calendar
            v-model="form.kt_at"
            dateFormat="dd/mm/yy"
            :class="{
              'p-invalid': v$.form.kt_at.$invalid && submitted,
            }"
            class="w-full"
          />
          <small
            v-if="
              (v$.form.kt_at.$invalid && submitted) ||
              v$.form.kt_at.$pending.$response
            "
            class="p-error"
            >{{ v$.form.kt_at.required.$message }}</small
          >
        </div>
        <div class="field col-12 md:col-12">
          <label>Dari</label>
          <Dropdown
            v-model="form.kas_id_from"
            :options="accounts"
            :class="{
              'p-invalid': v$.form.kas_id_from.$invalid && submitted,
            }"
            optionValue="id"
            optionLabel="nama"
            class="w-full"
          />
          <small
            v-if="
              (v$.form.kas_id_from.$invalid && submitted) ||
              v$.form.kas_id_from.$pending.$response
            "
            class="p-error"
            >{{ v$.form.kas_id_from.required.$message }}</small
          >
        </div>
        <div class="field col-12 md:col-12">
          <label>Ke</label>
          <Dropdown
            v-model="form.kas_id_to"
            :options="accounts"
            :class="{
              'p-invalid': v$.form.kas_id_to.$invalid && submitted,
            }"
            optionValue="id"
            optionLabel="nama"
            class="w-full"
          />
          <small
            v-if="
              (v$.form.kas_id_to.$invalid && submitted) ||
              v$.form.kas_id_to.$pending.$response
            "
            class="p-error"
            >{{ v$.form.kas_id_to.required.$message }}</small
          >
        </div>
        <div class="field col-12">
          <label> Nilai </label>
          <InputNumber
            v-model="form.nilai"
            :minFractionDigits="0"
            :class="{
              'p-invalid': v$.form.nilai.$invalid && submitted,
            }"
            mode="currency"
            currency="IDR"
            locale="id-ID"
            class="w-full"
            input-class="w-full"
          />
          <small
            v-if="
              (v$.form.nilai.$invalid && submitted) ||
              v$.form.nilai.$pending.$response
            "
            class="p-error"
            >{{ v$.form.nilai.required.$message }}</small
          >
        </div>
        <div class="field col-12">
          <label> Keterangan</label>
          <InputText
            v-model="form.keterangan"
            type="text"
            :class="{
              'p-invalid': v$.form.keterangan.$invalid && submitted,
            }"
            class="w-full"
          />
          <small
            v-if="
              (v$.form.keterangan.$invalid && submitted) ||
              v$.form.keterangan.$pending.$response
            "
            class="p-error"
            >{{ v$.form.keterangan.required.$message }}</small
          >
        </div>
      </div>
      <div class="flex justify-content-end align-items-end">
        <Button
          label="Tutup"
          icon="pi pi-times"
          @click="$emit('close')"
          class="p-button-text mr-2"
        />
        <Button
          :loading="loading"
          label="Simpan"
          icon="pi pi-check"
          type="submit"
        />
      </div>
    </form>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { helpers, required } from '@vuelidate/validators'

export default {
  setup: () => ({ v$: useVuelidate() }),
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default() {
        return {}
      },
    },
    accounts: {
      type: Array,
      default() {
        return []
      },
    },
  },
  data() {
    return {
      submitted: false,
    }
  },
  computed: {
    form() {
      return this.item
    },
  },
  methods: {
    handleSubmit(isFormValid) {
      this.submitted = true

      if (!isFormValid) {
        return
      }
      this.$emit('save', this.form)
    },
  },
  validations() {
    return {
      form: {
        kt_at: {
          required: helpers.withMessage('Tanggal harus diisi.', required),
        },
        kas_id_from: {
          required: helpers.withMessage('Kas Dari harus diisi.', required),
        },
        kas_id_to: {
          required: helpers.withMessage('Kas Ke harus diisi.', required),
        },
        nilai: {
          required: helpers.withMessage('Nilai harus diisi.', required),
        },
        keterangan: {
          required: helpers.withMessage('Keterangan harus diisi.', required),
        },
      },
    }
  },
}
</script>
